(ns ncr.cluster
  (:require
   [clojure.core.match :refer [match]]
   [cljs.core.async :as async :refer [<!] :refer-macros [go]]
   [tick.core :as t]
   [ncr.amplitude :as amp]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.backend :as b]
   [ncr.etc.modal :as m]
   [ncr.etc.pf :as pf]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.profile :as p]
   [ncr.etc.profile-pspec :as pspec]
   [ncr.widgets.pf :as wpf]
   [ncr.push]
   [ncr.auth]))

(def pspec [:local "ui/cluster"])

(defn- query-clusters []
  (b/!query
    [:clusters
     [:name :id :slug]]))

(defn use-clusters []
  (let [clusters (uix/state nil)]
    (uix/with-effect []
      (go
        (reset! clusters (or (<! (query-clusters)) []))))
    @clusters))

(defn- c-cluster-selector [id {:keys [control]} control-name clusters]
  (let [by-slug (u/index-by :slug clusters)]
    [rhf/c-controller
     {:name control-name
      :control control
      :rules
      {:required true}
      :render
      (fn [props]
        [wpf/c-pf-select
         {:toggle-id id
          :label-fn :name
          :variant :typeahead
          :max-height "200px"
          :position :right
          :selections
          (get by-slug (get-in props [:field :value]))
          :on-select
          (fn [_ {:keys [slug]} _]
            ((-> props :field :on-change) slug))}
         (sort-by :name clusters)])}]))

(defn- c-switch-dialog [slug clusters]
  (let
    [ref (uix/ref)
     modal-id :switch-cluster-modal
     {:keys [submit] :as form}
     (rhf/use-form
       {:should-focus-error false
        :default-values
        {:cluster slug}})]

    (m/use-submit-form modal-id ref submit)

    [m/c-modal
     {:title "Switch Cluster"
      :variant :small
      :id modal-id
      :ref ref
      :is-overflow-visible true
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click submit}
        "Ok"]
       [pf/c-button
        {:variant :link :on-click #(m/close! nil)} "Cancel"]]}

     (let [id (uix/memo #(gensym) [])]
       [pf/c-form {:on-submit submit}
        [rhf/c-form-group {:label "Cluster" :field-id id} :cluster form
         [c-cluster-selector id form :cluster clusters]]])]))

(defn- c-logout []
  [:a.pf-u-ml-sm {:on-click ncr.auth/signout!} "Logout"])

(defn- use-cluster []
  (let
    [clusters (u/if-ok [clusters (use-clusters)] clusters []) ;; XXX -jsn
     cluster (p/use-profile pspec ::nonexistent)
     result (uix/state nil)]

    (uix/effect!
      (fn []
        (when (and (some? @cluster) (some? clusters))
          (if-not (contains? (u/index-by :slug clusters) @cluster)
            (let [default (some->> clusters (sort-by :id) first :slug)]
              (reset! cluster default)
              (reset! result (or default ::no-cluster)))
            (reset! result @cluster))))
      [@cluster clusters])

    (uix/with-effect [@cluster]
      (when (= @cluster "demo")
        (go
          (let [accept (<! (pspec/read-demo-data-accepted! nil))]
            (when (or (nil? accept) (t/> (t/between accept (t/inst)) (t/of-days 7)))
              (go
                (<!
                  (m/!alert
                    {:actions-variant :ok
                     :body "Do not upload any personal data to the demo account, as all uploaded documents will be visible to all demo users."
                     :title "Data Privacy Warning"}))
                (pspec/write-demo-data-accepted! (t/inst))))))))
    [@result clusters]))

(defn c-with-cluster [body]
  (let [[cluster clusters] (use-cluster)]
    (uix/with-effect [cluster]
      (when (and (some? cluster) (not= cluster ::no-cluster))
        (reset! b/cluster-slug cluster)
        (reset! ncr.push/cluster-slug cluster)

        (amp/identify! :set {"Cluster" cluster})
        (amp/cluster-selected! {"Cluster" cluster})))

    (uix/with-effect [clusters]
      (amp/identify! :set {"Cluster Member" (->> clusters (map :name) (sort))}))

    (uix/effect! ncr.push/connect-effect-fn [])

    (if (some? cluster)
      (if (not= cluster ::no-cluster)
        body
        [w/c-bare-status
         [:span "Account does not belong to any cluster"
          [c-logout]]])

      [w/c-bare-status
       [:span "Loading clusters..."]])))

(defn- switch! [to track-origin]
  (go
    (let [from (<! (p/read-profile! pspec nil))]
      (amp/switch-cluster! {"From" from "To" to "Origin" track-origin}))
    (<! (p/write-profile! pspec to :no-notify? true))
    (js/window.location.replace
      (-> js/window.location.href (.split "#") (get 0)))))

(defn switch-modal! []
  (go
    (let [cluster (<! (p/read-profile! pspec nil))
          clusters (<! (query-clusters))]
      (when-let [selected (:cluster (<! (m/!modal #'c-switch-dialog cluster clusters)))]
        (switch! selected "Dialog")))))

(defn- c-switch-dropdown [{:keys [title clusters]}]
  (let [open? (uix/state false)]
    [pf/c-dropdown
     {:class :ncr-c-cluster-switch-dropdown
      :position :right
      :is-text true
      :is-plain true
      :is-open @open?
      :on-select #(reset! open? false)
      :toggle (pf/c-dropdown-toggle {:on-toggle #(swap! open? not)} title)
      :dropdown-items
      [[pf/c-dropdown-group
        {:label "Switch Cluster"}
        (for [{cluster-name :name :keys [id slug]} clusters]
          [pf/c-dropdown-item
           {:key id
            :on-click
            (fn []
              (reset! open? false)
              (switch! slug "Masthead"))}
           cluster-name])]]}]))

(defn c-toolbar-switch []
  (let
    [clusters (use-clusters)
     cluster @(p/use-profile pspec nil)]

    (if (> (count clusters) 1)
      [c-switch-dropdown
       {:title
        (->> clusters
          (filter #(-> % :slug (= cluster)))
          first
          :name)

        :clusters
        (->> clusters
          (remove #(-> % :slug (= cluster)))
          (sort-by :name))}]

      (-> clusters first :name))))

